import { useCapabilityValue } from '../store/devices/useCapabilityValue.ts';

import { useEventCallback } from './useEventCallback.ts';
import { useI18n } from './useI18nFormatters.tsx';

export const SYSTEM_CAPABILITIES = ['onoff', 'speaker_playing', 'button'];

export function useQuickAction({ device }) {
  const { i18n } = useI18n();

  const quickActionOverride = device?.ui?.quickActionOverride ?? null;
  let rawQuickActionId = device?.ui?.quickAction ?? null;

  if (quickActionOverride === '.none') {
    rawQuickActionId = null;
  } else if (
    typeof quickActionOverride === 'string' &&
    device?.capabilitiesObj?.[quickActionOverride] != null
  ) {
    rawQuickActionId = quickActionOverride;
  }

  const baseId = rawQuickActionId?.split('.')[0];

  const [value, setValue, capabilityObj] = useCapabilityValue({
    deviceId: device?.id,
    capabilityId: rawQuickActionId,
  });
  const isQuickActionSupported = isSupportedQuickActionCapability(capabilityObj);
  const quickActionId = isQuickActionSupported === true ? rawQuickActionId : null;

  let quickActionTitle = i18n.messageFormatter(`device.quickAction.default`);

  if (baseId != null && SYSTEM_CAPABILITIES.includes(baseId)) {
    if (capabilityObj?.getable === true) {
      quickActionTitle = i18n.messageFormatter(`device.quickAction.${baseId}.${value ?? false}`);
    } else if (capabilityObj != null) {
      quickActionTitle = i18n.messageFormatter(`device.quickAction.${baseId}`);
    }
  } else if (capabilityObj?.title != null) {
    quickActionTitle = capabilityObj.title;
  }

  const onQuickAction = useEventCallback(() => {
    if (isSupportedQuickActionCapability(capabilityObj) !== true) {
      return;
    }

    if (capabilityObj.setable === true && capabilityObj.getable === true) {
      const nextValue = value !== true;

      setValue(nextValue)
        .then((result) => {})
        .catch((error) => {});
    } else if (capabilityObj.setable === true) {
      setValue(true)
        .then((result) => {})
        .catch((error) => {});
    }
  });

  return { value, onQuickAction, quickActionId, quickActionTitle };
}

function isSupportedQuickActionCapability(capabilityObj) {
  if (capabilityObj == null) {
    return false;
  }

  if (capabilityObj.getable === true) {
    return capabilityObj.type === 'boolean';
  }

  return capabilityObj.setable === true;
}
